import { createAsyncThunk } from '@reduxjs/toolkit'
import MediationProcess from './mediation-process-model'
import {
  delete_mediationProcess,
  load_mediationProcesss,
  store_mediationProcess,
} from './mediationProcess-service'

export const LoadMediationProcesssAsync = createAsyncThunk<any, any>(
  'composer/load/mediationProcess',
  async (params: { uid: string }) => {
    return await load_mediationProcesss(params)
  },
)

export const CreateMediationProcessAsync = createAsyncThunk<any, any>(
  'composer/create/mediationProcess',
  async (params: MediationProcess) => {
    return await store_mediationProcess(params)
  },
)

export const DeleteMediationProcessAsync = createAsyncThunk<any, any>(
  'composer/delete/mediationProcess',
  async (params) => {
    return await delete_mediationProcess(params)
  },
)
